import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0a0c', // midnight
      paper: '#121214',   // charcoal
    },
    primary: {
      main: '#00f0ff',    // electric
    },
    text: {
      primary: '#f8fafc',
      secondary: '#94a3b8', // slate
    },
    custom: {
      midnight: '#0a0a0c',
      charcoal: '#121214',
      electric: '#00f0ff',
      slate: '#94a3b8',
      white5: 'rgba(255, 255, 255, 0.05)',
      white10: 'rgba(255, 255, 255, 0.1)',
      white20: 'rgba(255, 255, 255, 0.2)',
    }
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    mono: '"JetBrains Mono", monospace',
  },
});